module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'alfa-design': _vm.alfaDesign, 'default-design': !_vm.alfaDesign
    }
  }, [_c('md-dialog', {
    ref: "forgotPassword",
    attrs: {
      "md-open-from": "#forgotPassword",
      "md-close-to": "#forgotPassword"
    }
  }, [_c('md-dialog-title', [_vm._v("Password reset")]), _vm._v(" "), _c('md-dialog-content', [_c('div', [_vm._v("Please enter your email address.")]), _vm._v(" "), _c('form', {
    staticClass: "forgot-password-form",
    class: {
      'default-forgot-password-dialog-content': !_vm.alfaDesign
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.closeDialog('forgotPassword', true)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "name": "email"
    },
    model: {
      value: (_vm.forgottenEmail),
      callback: function($$v) {
        _vm.forgottenEmail = $$v
      },
      expression: "forgottenEmail"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "forgot-password-actions",
    class: {
      'default-forgot-password-actions': !_vm.alfaDesign
    }
  }, [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog('forgotPassword', false)
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog('forgotPassword', true)
      }
    }
  }, [_vm._v("\n        Ok\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-area"
  }, [(_vm.alfaDesign) ? _c('div', {
    staticClass: "alfa-auth-window"
  }, [_c('div', {
    staticClass: "alfa-auth-info"
  }, [_c('h1', [_vm._v("The algorithm factory")]), _vm._v(" "), _c('h2', [_vm._v("Let's get started")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "alfa-logo-holder"
  }, [_c('span', [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.imagesUrls), function(url, index) {
    return (index === _vm.imageNum) ? _c('img', {
      key: index + url,
      staticClass: "temp-image",
      attrs: {
        "src": url,
        "alt": "Quinyx logo"
      }
    }) : _vm._e()
  }), 0)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alfa-auth-form"
  }, [_c('h2', [_vm._v("Enter your credentials")]), _vm._v(" "), _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "custom-input-block"
  }, [_c('md-input-container', [_c('label', [_vm._v("Email or Username")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "email",
      "type": "text"
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-input-block"
  }, [_c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "password",
      "type": "password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-helpers"
  }, [_c('div', {
    staticClass: "auth-helpers-part"
  }, [(!_vm.isExternal) ? _c('md-checkbox', {
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }, [_vm._v("\n                Remember me\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isExternal) ? _c('md-checkbox', {
    model: {
      value: (_vm.rememberAll),
      callback: function($$v) {
        _vm.rememberAll = $$v
      },
      expression: "rememberAll"
    }
  }, [_vm._v("\n                Remember me\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-helpers-part"
  }, [_c('div', {
    attrs: {
      "id": "forgotPassword"
    },
    on: {
      "click": function($event) {
        return _vm.openDialog('forgotPassword')
      }
    }
  }, [_vm._v("\n                Forgot your password\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "auth-actions"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "submit": _vm.login
    }
  }, [_vm._v("\n              Log in\n            ")])], 1), _vm._v(" "), _vm._m(0)])])]) : _c('div', {
    staticClass: "auth-window"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Quinyx logo"
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Email or Username")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "email",
      "type": "text"
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "password",
      "type": "password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-helpers"
  }, [_c('div', {
    staticClass: "auth-helpers-part"
  }, [(!_vm.isExternal) ? _c('md-checkbox', {
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }, [_vm._v("\n              Remember me\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isExternal) ? _c('md-checkbox', {
    model: {
      value: (_vm.rememberAll),
      callback: function($$v) {
        _vm.rememberAll = $$v
      },
      expression: "rememberAll"
    }
  }, [_vm._v("\n              Remember me\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-helpers-part"
  }, [_c('div', {
    attrs: {
      "id": "forgotPassword"
    },
    on: {
      "click": function($event) {
        return _vm.openDialog('forgotPassword')
      }
    }
  }, [_vm._v("\n              Forgot your password\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "auth-actions"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "submit": _vm.login
    }
  }, [_vm._v("\n            Log in\n          ")]), _vm._v(" "), _c('multiselect', {
    staticClass: "sso-button",
    attrs: {
      "options": _vm.ssoOptions,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "placeholder": "Log in With SSO",
      "selectLabel": "",
      "label": "name",
      "deselectLabel": "remove"
    },
    model: {
      value: (_vm.selectedSso),
      callback: function($$v) {
        _vm.selectedSso = $$v
      },
      expression: "selectedSso"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary sso-submit-button",
    class: {
      'sso-submit-button-disabled': !_vm.selectedSso
    },
    on: {
      "click": function($event) {
        return _vm.SSOLogin()
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_tab")])], 1)], 1), _vm._v(" "), _vm._m(1)], 1)])]), _vm._v(" "), _c('md-dialog', {
    ref: "errorDialog",
    class: 'error-dialog'
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.dialogErrorMessage))]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "error-dialog-content",
    class: {
      'default-error-dialog-content': !_vm.alfaDesign
    }
  }, [(_vm.dialogErrorCode === 500) ? _c('div', [_c('p', [_vm._v("Please try the following:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": _vm.systemStatusUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n              Check system status\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.faqUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n              Check FAQ: Why I cannot access my application?\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.widgetBrainSupportEmail
    }
  }, [_vm._v("\n              Contact Widget Brain Support\n            ")])])])]) : (_vm.dialogErrorCode === 403) ? _c('div', [_c('p', [_vm._v("Please try the following:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": _vm.faqUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n              Check FAQ: Why I cannot access my application?\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.widgetBrainSupportEmail
    }
  }, [_vm._v("\n              Contact Widget Brain Support\n            ")])])])]) : (_vm.dialogErrorCode === 401) ? _c('div', [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialog('forgotPassword')
      }
    }
  }, [_vm._v("Forgot your password")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.faqUrl,
      "target": "_blank"
    }
  }, [_vm._v("Check Login FAQ")])])])]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "error-dialog-actions",
    class: {
      'default-error-dialog-actions': !_vm.alfaDesign
    }
  }, [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeErrorDialog
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-demo"
  }, [_c('h2', [_vm._v("No account yet?")]), _vm._v(" "), _c('a', {
    staticClass: "request-demo-link",
    attrs: {
      "href": "https://widgetbrain.com/demo/",
      "target": "_blank"
    }
  }, [_vm._v("\n              Request a demo\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-demo"
  }, [_c('a', {
    staticClass: "request-demo-link",
    attrs: {
      "href": "https://widgetbrain.com/demo/",
      "target": "_blank"
    }
  }, [_vm._v("\n            Or request a demo\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66fa2b1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 313
// module chunks = 2